<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'medium'">
    <div slot="title">{{getTitleText}}</div>
    <div slot="body">
      <form v-on:submit.prevent="submitForm">
        <div class="row">
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label>
              {{'Varriant'|translate}}
              <span class="required">(*)</span>
            </label>
            <select class="form-control" :disabled="item.id" v-model="item.varriant_id" required>
              <option disabled value>{{'Please select one'|translate}}</option>
              <option
                v-for="(varriant) in list_varriants"
                :key="varriant.id"
                v-bind:value="varriant.id"
              >{{ varriant.name }} ({{varriant.product_name}})</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label>{{'Total Price'|translate}}</label>
            <input type="type" disabled v-bind:value="toCommas(totalPrice)" class="form-control" />
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="mt20">
                {{'Amount'|translate}}
                <span class="required">(*)</span>
              </label>
              <input
                type="number"
                v-model="item.amount"
                :disabled="item.id && purchase.status !=0"
                required
                ref="amount"
                :placeholder="'Amount'|translate"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="mt20">
                {{'Price'|translate}}
                <span class="required">(*)</span>
              </label>
              <input
                v-model="item.price"
                ref="price"
                :disabled="item.id && purchase.status !=0"
                :placeholder="'Price'|translate"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row" v-if="purchase.status >= 2 && user.id == purchase.seller_user_id">
          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="mt20">
                {{'From serial'|translate}}
                <span class="required">(*)</span>
              </label>
              <input
                type="number"
                v-model="item.from_serial"
                
                required
                ref="from_serial"
                :placeholder="'From serial'|translate"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="mt20">
                {{'To serial'|translate}}
                <span class="required">(*)</span>
              </label>
              <input
                type="number"
                v-model="item.to_serial"
                
                required
                ref="to_serial"
                :placeholder="'To serial'|translate"
                class="form-control"
              />
            </div>
          </div>
        <div class="col-md-12 col-sm-12 col-xs-12" v-if="harvests.length > 0">
            <div class="form-group">
              <label class="mt20">
                {{'Select harvest'|translate}}
              </label>
            <select class="form-control" v-model="item.harvest_id" >
              <option disabled value>{{'Please select one'|translate}}</option>
              <option
                v-for="(harvest) in harvests"
                :key="harvest.id"
                v-bind:value="harvest.id"
              >{{ harvest.kg }} ({{harvest.season_name}})</option>
            </select>
            </div>
          </div>
          
        </div>
        <p>
          <button class="btn btn-info mt20" type="submit" :disabled="working">
            <i v-if="working" class="fas fa-spinner fa-spin"></i>
            {{getOKText}}
          </button>
        </p>
      </form>
    </div>
  </mymodal>
</template>
<script>
import mymodal from "@/components/elements/Modal";
import Utils from "@/helpers/utils";
import Loading from "@/components/elements/Loading";

//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "FormSubUser",
  components: {
    mymodal,
    Loading
  },
  props: ["pass_data", "list_varriants", "purchase","user"],
  computed: {
    totalPrice() {
      return this.item.amount * this.item.price;
    },
    getTitleText() {
      if (this.item.id) {
        return this.$t("Update purchase detail");
      } else {
        return this.$t("Add purchase detail");
      }
    },
    getOKText() {
      if (this.item.id) {
        return this.$t("Update");
      } else {
        return this.$t("Add");
      }
    }
  },
  data() {
    let dateFormat = "DD/MM/YYYY";
    return {
      working: false,
      src_image: "/static/images/no-photo.jpg",
      selected_seller: null,
      dateFormat: dateFormat,
      item: {},
      harvests:[]
    };
  },
  created() {
    // clone from original params
  },

  methods: {
    toCommas(value) {
      return Utils.toCommas(value);
    },
    defaultValue() {
      return {
        amount: 0,
        price: 0,
        varriant_id: "",
        purchase_id: this.purchase.id
      };
    },
    open() {
      this.$refs.theModal.open();
      if (this.pass_data) {
        this.item = JSON.parse(JSON.stringify(this.pass_data));
        if (this.purchase.status == 2 && this.user.id == this.purchase.seller_user_id && this.purchase.seller_type == "farmer"){
          this.getHarvests();
        }
      } else {
        this.item = this.defaultValue();
      }
    },
    getHarvests(){
     let data = {
        offset: 0,
        limit: -1,
        varriant_id: this.item.varriant_id
      };
      
      Utils.request(this, true, "land")
        .get(`/manageHarvest/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          console.log('response',response)
          let data = response.data;
          if (data.status === "ok") {
            this.harvests = data.data.list;  
          }
        })
        .catch(error => {
          
        });
    },
    submitForm() {
      let data = JSON.parse(JSON.stringify(this.item));

      let request;
      if (this.item.id) {
        // PUT request does not support validation
        request = Utils.request(this, true, "purchase").put(
          `/manageOrderDetail/`,
          data
        );
      } else {
        request = Utils.request(this, true, "purchase").post(
          `/manageOrderDetail/`,
          data
        );
      }
      this.working = true;
      request
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.$refs.theModal.close();
            this.$emit("modalData", {});
          } else {
            Utils.showError(this, this.$t(data.data));
          }
        })
        .catch(error => {
          
          Utils.showErrorMessage(this, error.response);
        }).finally(()=>{
          this.working = false;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Purchase/FormPurchaseDetail.vue